/**
 * v3.0.33 - Tema teshis modulu (yalnizca settings.diagnostics_enable acikken yuklenir).
 *
 * Kullanim:
 *   - Herhangi bir sayfaya ?diag=1 ekle -> rapor konsola yazilir + kose rozeti.
 *   - Konsoldan: ecDiag()            -> rapor nesnesi
 *                ecDiag({cart:true}) -> /cart.js sayaci da dahil (ag istegi atar)
 *
 * Bagimliliksizdir; jQuery gerektirmez. Ziyaretci verisi toplamaz,
 * hicbir yere gonderim yapmaz - rapor yalnizca tarayici konsolundadir.
 */
(function () {
  'use strict';

  function state() {
    var el = document.getElementById('ec-diag-state');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return { parseError: String(e) }; }
  }

  function probeDom() {
    var de = document.documentElement;
    var body = document.body;
    var text = body ? body.innerText : '';
    var liquid = (text.match(/Liquid error[^\n]{0,120}/g) || []).slice(0, 8);
    var tmiss = (text.match(/Translation missing[^\n]{0,90}/g) || []).slice(0, 8);

    var small = 0;
    document.querySelectorAll('a[href],button,input:not([type=hidden]),select,summary,[role=button]').forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var s = getComputedStyle(e);
      if (s.visibility === 'hidden' || s.display === 'none') return;
      if (r.width < 24 || r.height < 24) small++;
    });

    var imgs = Array.prototype.slice.call(document.images);
    return {
      liquidErrors: liquid,
      translationMissing: tmiss,
      h1Count: document.querySelectorAll('h1').length,
      hOverflow: de.scrollWidth > de.clientWidth + 1,
      smallTargets: small,
      imgNoAlt: imgs.filter(function (i) { return !i.hasAttribute('alt'); }).length,
      imgBroken: imgs.filter(function (i) { return i.complete && i.naturalWidth === 0 && i.loading !== 'lazy'; }).length,
      jsonLd: document.querySelectorAll('script[type="application/ld+json"]').length,
      metaDescription: !!document.querySelector('meta[name="description"]'),
      canonical: !!document.querySelector('link[rel="canonical"]')
    };
  }

  function probeSections() {
    return Array.prototype.slice.call(document.querySelectorAll('.shopify-section')).map(function (s) {
      var id = s.id.replace('shopify-section-', '');
      var m = id.match(/__(.+?)(?:_[A-Za-z0-9]{6,8})?$/);
      return { id: id.slice(0, 60), type: m ? m[1] : id, h: Math.round(s.getBoundingClientRect().height) };
    });
  }

  function probeResources() {
    var res = performance.getEntriesByType('resource');
    var byType = {}, seen = {}, dupes = [];
    var totalKB = 0;
    res.forEach(function (r) {
      var t = r.initiatorType || 'other';
      var kb = (r.transferSize || 0) / 1024;
      totalKB += kb;
      byType[t] = byType[t] || { n: 0, kb: 0 };
      byType[t].n++; byType[t].kb += kb;
      var key = r.name.split('?')[0];
      if (seen[key] && /\.(js|css)$/.test(key)) dupes.push(key.split('/').pop());
      seen[key] = true;
    });
    Object.keys(byType).forEach(function (k) { byType[k].kb = Math.round(byType[k].kb); });
    var cssTags = document.querySelectorAll('link[rel="stylesheet"]').length;
    var scriptTags = document.querySelectorAll('script[src]').length;
    var htmlKB = Math.round(document.documentElement.outerHTML.length / 1024);
    return {
      count: res.length,
      totalKB: Math.round(totalKB),
      byType: byType,
      duplicateAssets: dupes.slice(0, 10),
      cssTags: cssTags,
      scriptTags: scriptTags,
      htmlKB: htmlKB,
      budget: {
        cssTags: cssTags <= 40,
        scriptTags: scriptTags <= 45,
        htmlKB: htmlKB <= 450
      }
    };
  }

  function probeScripts() {
    var blocking = 0;
    document.querySelectorAll('head script[src]:not([defer]):not([async]):not([type="module"])').forEach(function () { blocking++; });
    return {
      parserBlocking: blocking,
      jquery: typeof window.jQuery === 'function' ? (window.jQuery.fn && window.jQuery.fn.jquery) : 'yok',
      jqueryDeferred: (function () { var s = document.querySelector('script[src*="jquery.min.js"]'); return s ? s.hasAttribute('defer') : null; })(),
      swiper: typeof window.Swiper === 'function',
      swiperMarkupOrphan: !!document.querySelector('.swiper, [data-swiper-slider]') && typeof window.Swiper === 'undefined',
      fancybox: typeof window.Fancybox === 'function',
      modelViewer: !!window.customElements.get('model-viewer') || !!document.querySelector('model-viewer')
    };
  }

  function issueCategory(source, message) {
    var src = String(source || '').toLowerCase();
    var msg = String(message || '').toLowerCase();

    if (/(chrome|moz|safari)-extension:/.test(src) ||
        /extension context|asynchronous response|message channel closed/.test(msg)) return 'extension';

    if (/cdn\.shopify\.com\/s\/files\/.+\/assets\//.test(src)) return 'theme';

    if (/shopify|shopifycdn|bugsnag|monorail|trekkie/.test(src + ' ' + msg)) return 'platform';

    try {
      if (src && new URL(src, location.href).origin === location.origin) return 'theme';
    } catch (e) { /* URL olmayan stack/metin */ }

    if (src) return 'thirdParty';
    return 'unknown';
  }

  function classifyIssues(errors, rejections) {
    var groups = { theme: [], platform: [], extension: [], thirdParty: [], unknown: [] };

    function add(issue) {
      var normalized = typeof issue === 'string' ? { m: issue, s: '' } : (issue || { m: '', s: '' });
      groups[issueCategory(normalized.s, normalized.m)].push(normalized);
    }

    errors.forEach(add);
    rejections.forEach(add);

    return {
      counts: {
        theme: groups.theme.length,
        platform: groups.platform.length,
        extension: groups.extension.length,
        thirdParty: groups.thirdParty.length,
        unknown: groups.unknown.length
      },
      groups: groups
    };
  }

  var vitals = { LCP: null, CLS: 0 };
  try {
    new PerformanceObserver(function (l) {
      var e = l.getEntries(); if (e.length) vitals.LCP = Math.round(e[e.length - 1].startTime);
    }).observe({ type: 'largest-contentful-paint', buffered: true });
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (e) { if (!e.hadRecentInput) vitals.CLS += e.value; });
    }).observe({ type: 'layout-shift', buffered: true });
  } catch (e) { /* eski tarayici */ }

  function report(opts) {
    var jsErrors = (window.__ecDiag && window.__ecDiag.errors) || [];
    var rejections = (window.__ecDiag && window.__ecDiag.rejections) || [];
    var r = {
      state: state(),
      dom: probeDom(),
      scripts: probeScripts(),
      resources: probeResources(),
      sections: probeSections(),
      vitals: { LCP_ms: vitals.LCP, CLS: Math.round(vitals.CLS * 1000) / 1000 },
      jsErrors: jsErrors,
      rejections: rejections,
      errorSummary: classifyIssues(jsErrors, rejections)
    };
    if (opts && opts.cart) {
      return fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) {
        r.cart = { itemCount: c.item_count, currency: c.currency };
        return r;
      });
    }
    return r;
  }

  window.ecDiag = report;

  function dialogOpen() {
    var dialogs = document.querySelectorAll(
      'quick-add-modal[open], dialog[open], .product-media-modal[open], ' +
      '[role="dialog"][aria-modal="true"]:not([aria-hidden="true"])'
    );
    return Array.prototype.some.call(dialogs, function (dialog) {
      var rect = dialog.getBoundingClientRect();
      var style = getComputedStyle(dialog);
      return !!rect.width && !!rect.height && style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function toolbarSafeBottom() {
    var toolbar = document.querySelector('.mtb__bar');
    if (!toolbar) return 10;
    var rect = toolbar.getBoundingClientRect();
    var style = getComputedStyle(toolbar);
    if (!rect.width || !rect.height || style.display === 'none' || style.visibility === 'hidden') return 10;
    if (rect.top >= innerHeight || rect.bottom <= 0) return 10;
    return Math.max(10, Math.round(innerHeight - rect.top + 10));
  }

  function badge(r) {
    var classified = r.errorSummary.counts;
    var themeErrN = r.dom.liquidErrors.length + classified.theme;
    var errN = r.dom.liquidErrors.length + r.jsErrors.length + r.rejections.length;
    var compactText = 'diag v' + (r.state.version || '?') + ' | themeErr:' + themeErrN + ' | total:' + errN;
    var fullText = compactText + ' | tpl:' + (r.state.template || '?') +
      ' | p:' + classified.platform + ' | ext:' + classified.extension +
      ' | 3p:' + classified.thirdParty + ' | ?:' + classified.unknown +
      ' | ovf:' + (r.dom.hOverflow ? 'VAR' : 'yok') +
      ' | h1:' + r.dom.h1Count + ' | css:' + r.resources.cssTags +
      ' | js:' + r.resources.scriptTags + ' | html:' + r.resources.htmlKB + 'KB' +
      ' | ldjson:' + r.dom.jsonLd + ' | cls:' + r.vitals.CLS +
      (r.vitals.LCP_ms ? ' | LCP:' + r.vitals.LCP_ms + 'ms' : '');
    var expanded = false;
    var el = document.createElement('button');
    el.type = 'button';
    el.id = 'ec-diag-badge';
    el.style.cssText = 'position:fixed;left:10px;bottom:10px;z-index:2147483000;display:inline-flex;align-items:center;min-height:44px;background:rgba(0,0,0,.88);color:#fff;font:12px/1.5 monospace;padding:8px 12px;border-radius:999px;border:1px solid rgba(255,255,255,.25);cursor:pointer;max-width:70vw;text-align:left;white-space:normal';
    el.textContent = compactText;
    el.setAttribute('aria-expanded', 'false');
    el.setAttribute('aria-label', 'Theme diagnostics. Click to expand or collapse.');
    // Expose only the already-truncated, non-sensitive error summaries in the
    // DOM so preview automation can inspect them without console access.
    el.dataset.errorReport = JSON.stringify({
      liquidErrors: r.dom.liquidErrors,
      jsErrors: r.jsErrors,
      rejections: r.rejections,
      classification: r.errorSummary
    });
    el.title = themeErrN
      ? 'Tema hatasi var. Ayrinti data-error-report ve ecDiag() icinde.'
      : (errN ? 'Tema disi hata sinyalleri siniflandirildi. Ayrinti icin tikla.' : 'Hata yok. Ayrinti icin tikla.');
    el.addEventListener('click', function () {
      expanded = !expanded;
      el.textContent = expanded ? fullText : compactText;
      el.style.borderRadius = expanded ? '8px' : '999px';
      el.setAttribute('aria-expanded', String(expanded));
    });
    document.body.appendChild(el);

    function syncPosition() {
      el.style.display = dialogOpen() ? 'none' : 'inline-flex';
      el.style.bottom = toolbarSafeBottom() + 'px';
    }

    syncPosition();
    addEventListener('resize', syncPosition, { passive: true });
    new MutationObserver(syncPosition).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'class', 'aria-hidden']
    });
  }

  if (/[?&]diag=1/.test(location.search)) {
    window.addEventListener('load', function () {
      setTimeout(function () {
        var r = report();
        try {
          console.groupCollapsed('%cec-diag v' + r.state.version, 'background:#000;color:#0f0;padding:2px 6px');
          console.log('state', r.state);
          console.log('dom', r.dom);
          console.log('scripts', r.scripts);
          console.log('resources', r.resources);
          console.table(r.sections);
          console.log('vitals', r.vitals);
          console.log('errorSummary', r.errorSummary);
          if (r.jsErrors.length) console.warn('jsErrors', r.jsErrors);
          if (r.rejections.length) console.warn('rejections', r.rejections);
          console.groupEnd();
        } catch (e) { console.log('ec-diag', r); }
        badge(r);
      }, 800);
    });
  }
})();
